module.exports = __webpack_public_path__ + "static/media/rank1.6f7ff42a.svg";